import '../css/moduleprogressbar.css';
import React, { useState, useEffect } from 'react';


function ModuleProgressBar(props) {

	let progressBarCss = {
						"height" : "5px",
					  	"width" : "90%",
					  	"display": "flex",
					  	"msFlexDirection": "column",
					  	"flexDirection": "column",
					  	",sFlexPack": "center",
					 	"justifyContent": "center",
					  	"color": "#fff",
					  	"backgroundColor" : "red",
					  	"textAlign": "center",
					  	"whiteSpace": "nowrap"
					}

	const [progressBarStyle, setProgressBarStyle] = useState(progressBarCss);
	const [progressPercent, setProgressPercent] = useState('')

	useEffect(() => {
		let progressPercentage = "0"
		let newProgressBarStyle = Object.assign({}, progressBarCss);
		if (!isNaN(props.progress) && props.progress != "") {
			progressPercentage = props.progress / 100
			setProgressPercent(props.progress)
			if ( props.progress >= 100) {
				newProgressBarStyle['width'] = "100%"
			} else {
				newProgressBarStyle['width'] = props.progress + "%"
			}	
			if (progressPercentage > 0.7) {
				newProgressBarStyle['backgroundColor'] = "#5fd156"
				setProgressBarStyle(newProgressBarStyle)
			} else if ( progressPercentage > 0.5) {
				newProgressBarStyle['backgroundColor'] = "#ff8800"
				setProgressBarStyle(newProgressBarStyle)
			} else {
				newProgressBarStyle['backgroundColor'] = "#f52a08"
				setProgressBarStyle(newProgressBarStyle)
			}
	} else {
		setProgressPercent("0")
		newProgressBarStyle['backgroundColor'] = "#f52a08"
		newProgressBarStyle['width'] = "1%"
		setProgressBarStyle(newProgressBarStyle)
	}
	} ,[props.progress])

	return(
		<div className="module-progress-bar-container">
			<div class="module-progress-bar-details">
				<div class="module-progress-bar-percentage">
				  {progressPercent + "%"}
				</div>
			</div>
			<div class="module-progress-bar-envelope"> 
				<div style={progressBarStyle}></div>
			</div>
		</div>
	);

}

export default ModuleProgressBar